module.exports = __webpack_public_path__ + "img/case03.3ab981a0.jpg";